import { render } from "./ExtraSmallSentimentIcon.vue?vue&type=template&id=4c01e610&scoped=true"
import script from "./ExtraSmallSentimentIcon.vue?vue&type=script&lang=js"
export * from "./ExtraSmallSentimentIcon.vue?vue&type=script&lang=js"

import "./ExtraSmallSentimentIcon.vue?vue&type=style&index=0&id=4c01e610&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c01e610"]])

export default __exports__